module.exports = __webpack_public_path__ + "static/media/warehousing.5c09c803.png";